<template>
  <div>
    <canvas :id="name"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js'

export default {
    props: {
        name: {
            type: String,
            default: () => "line-chart",
            required: false,
        },
        graphData: {
            type: Object,
            required: true,
        },
        options: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            graph: null,
            chartData: {
                type: 'line',
                data: this.graphData,
                options: this.options
            },
        }
    },
    mounted() {
        const ctx = document.getElementById(this.name);
        this.graph = new Chart(ctx, this.chartData);
    },
    watch: {
        graphData: {
            handler(newValue){
                this.graph.data = newValue
                this.graph.update();
            },
            deep: true
        },
    }
}
</script>